import Travelers from './travelers-view';

export default Travelers;
